import React from 'react';

const SectionLabel = ({ as: Component = 'label', className = '', children }) => (
  <Component className={`text-xs font-bold text-neutral-400 uppercase tracking-wider ${className}`}>
    {children}
  </Component>
);

export default SectionLabel;
